import React, { useState, useEffect } from "react";
import "./newsSection.css";

function NewsSection({ data }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [newsPerPage] = useState(5);
  const [pageNumbers, setPageNumbers] = useState([]);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = data.slice(indexOfFirstNews, indexOfLastNews);

  useEffect(() => {
    const totalPageNumbers = Math.ceil(data.length / newsPerPage);

    const startPage = Math.max(currentPage - 2, 1);
    const endPage = Math.min(currentPage + 2, totalPageNumbers);

    const numbers = [];

    if (startPage !== 1) {
      numbers.push(1);
      numbers.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      numbers.push(i);
    }

    if (endPage !== totalPageNumbers) {
      numbers.push("...");
      numbers.push(totalPageNumbers);
    }

    setPageNumbers(numbers);
  }, [currentPage, data.length, newsPerPage]);

  const renderNews = (news) => {
    const publishDate = new Date(news.publish_date);
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const ordinalSuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const formattedDate = `${monthNames[publishDate.getMonth()]} ${publishDate.getDate()}${ordinalSuffix(publishDate.getDate())}, ${publishDate.getFullYear()}`;


    return (
      <div className="news-item" key={news.id}>
        <div className="news-image">
          <img 
              src={news.image_url} 
              alt={news.title} 
              onError={(e)=>{e.target.onerror = null; e.target.src="https://openclipart.org/download/245742/Angelic-Smiley.svg"}}
          />
        </div>
        <div className="news-details">
          <div className="news-heading">
            <a href={news.link} target="_blank" rel="noopener noreferrer">
              {news.title}
            </a>
          </div>
          <div className="news-excerpt">
            {news.by_line}
          </div>
          <div className="news-source">
            <img src={news.news_source_favicon_url} alt={news.news_source_name} />
            <p className="news-source-content">{news.news_source_name}</p>
            <p className="news-source-content">
              <i className="fa-sharp fa-solid fa-grip-lines-vertical"></i>
            </p>
            <p className="news-source-content">{formattedDate}</p>
          </div>
        </div>
      </div>
    );
  };

  const handlePageClick = (event) => {
    const page = event.target.id;
    if (page === "...") {
      return;
    }
    setCurrentPage(Number(page));
  };

  return (
    <div className="news-section">
      {currentNews.map(renderNews)}
      <ul id="page-numbers">
        {pageNumbers.map((number) => (
    <li 
      key={number} 
      id={number} 
      onClick={handlePageClick} 
      className={number === currentPage ? "page-number--current" : ""}
    >
      {number}
    </li>
  ))}
</ul>

    </div>
  );
}

export default NewsSection;
